module.exports = __webpack_public_path__ + "img/quantum-wifi-nowifi-250x139.34726bd5.png";